var render, staticRenderFns
import script from "./balancing-payment-create.vue?vue&type=script&lang=js&"
export * from "./balancing-payment-create.vue?vue&type=script&lang=js&"
import style0 from "./balancing-payment-create.vue?vue&type=style&index=0&id=b10870a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10870a4",
  null
  
)

export default component.exports